import { render, staticRenderFns } from "./ModalUpdateAuthorTopic.vue?vue&type=template&id=03c263a6&"
import script from "./ModalUpdateAuthorTopic.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateAuthorTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports